<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'TABLE.DOCTORS_LIST' | translate"
    [class]="'card-head-lg'"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template ngxPermissionsOnly="canAddDoctor">
          <button mat-raised-button (click)="addDoctor()" class="btn btn-primary">
            <span
              inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
              class="svg-icon svg-icon-md"
            ></span>
            <span>{{ 'TABLE.ADD_DOCTOR' | translate }}</span>
          </button>
        </ng-template>
        <button
          mat-raised-button
          matTooltip="Export as CSV"
          class="btn btn-icon btn-primary ml-2"
          (click)="exportDoctorsAsCSV($event)"
        >
          <i class="fas fa-download"></i>
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <button
          style="width: 140px !important"
          class="btn btn-sm btn-light-{{ getItemCssClassByStatus(searchIsActiveSelect) }} mr-4"
          (click)="toggleStatus($event)"
        >
          {{ getItemStatusString(searchIsActiveSelect) }} Doctors
        </button>
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetSearchInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table #sort="matSort" matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCTOR.INPUT.ID' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let doctor">
            <span
              [matTooltip]="canViewDoctor() ? 'View Doctor' : null"
              [class.clickable]="canViewDoctor()"
              (click)="viewDoctorDblclick(doctor.id, doctor)"
              >{{ doctor.id }}</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchId">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCTOR.INPUT.ID' | translate }}</mat-label>
              <input
                matInput
                [placeholder]="'DOCTOR.INPUT.ID' | translate"
                [(ngModel)]="searchIdInput"
              />
              <button
                *ngIf="searchIdInput"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchIdInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="profile">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell
            *matCellDef="let doctor"
            class="profile-pic clickable justify-content-center"
            (click)="showDoctorPhoto(doctor)"
          >
            <kt-user-photo
              [create]="'false'"
              [size]="30"
              [type]="'object'"
              [editable]="false"
              [user$]="{ profileUrl: doctor.pre_signed_url?.url }"
              [entityTypeAndGender]="{ type: 'DOCTOR', gender: doctor.gender }"
            ></kt-user-photo>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchProfile">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCTOR.DOCTOR' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let doctor" class="flex-column align-items-start">
            <span
              [matTooltip]="canViewDoctor() ? 'View Doctor' : null"
              [class.clickable]="canViewDoctor()"
              (click)="viewDoctorDblclick(doctor.id + doctor.first_name, doctor)"
            >
              {{ doctor.first_name }} {{ doctor.middle_name }} {{ doctor.last_name }}
              {{ doctor.last_name2 }}
            </span>
            <a href="mailto:{{ doctor.email }}">{{ doctor.email }}</a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchNameEmail">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCTOR.INPUT.NAME_EMAIL' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchNameEmailInput"
                [placeholder]="'DOCTOR.INPUT.NAME_EMAIL' | translate"
              />
              <button
                *ngIf="searchNameEmailInput"
                matSuffix
                mat-icon-button
                (click)="searchNameEmailInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="npi">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCTOR.INPUT.NPI' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let doctor">{{ doctor.npi }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchNPI">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCTOR.INPUT.NPI' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchNPIInput"
                [placeholder]="'DOCTOR.INPUT.NPI' | translate"
              />
              <button
                *ngIf="searchNPIInput"
                matSuffix
                mat-icon-button
                (click)="searchNPIInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="sln">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCTOR.INPUT.SLN' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let doctor">{{ doctor.sln }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchSLN">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCTOR.INPUT.SLN' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchSLNInput"
                [placeholder]="'DOCTOR.INPUT.SLN' | translate"
              />
              <button
                *ngIf="searchSLNInput"
                matSuffix
                mat-icon-button
                (click)="searchSLNInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="officeName">
          <mat-header-cell *matHeaderCellDef>{{
            'DOCTOR.INPUT.OFFICE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let doctor">{{ doctor.office_name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchOfficeName">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchOfficeAutocomplete
              [label]="'DOCTOR.INPUT.OFFICE' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getOfficeAutocomplete"
              [optionFormatter]="formatOfficeOption"
              [valueFormatter]="formatOfficeOption"
              [control]="searchOfficeAutocomplete"
              [required]="false"
              [readOnly]="false"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="officePhone">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCTOR.INPUT.OFFICE_PHONE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let doctor"
            >{{ doctor.office_phone | phoneFormat }}
            {{ doctor.extension ? ' Ext. ' + doctor.extension : '' }}</mat-cell
          >
        </ng-container>
        <ng-container matColumnDef="searchOfficePhone">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCTOR.INPUT.OFFICE_PHONE' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchOfficePhoneInput"
                [mask]="'(000) 000-0000'"
                [placeholder]="'DOCTOR.INPUT.OFFICE_PHONE' | translate"
              />
              <button
                *ngIf="searchOfficePhoneInput"
                matSuffix
                mat-icon-button
                (click)="searchOfficePhoneInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="fax">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCTOR.INPUT.FAX' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let doctor">{{ doctor.fax | phoneFormat }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchFax">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCTOR.INPUT.FAX' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchFaxInput"
                [mask]="'(000) 000-0000'"
                [placeholder]="'DOCTOR.INPUT.FAX' | translate"
              />
              <button
                *ngIf="searchFaxInput"
                matSuffix
                mat-icon-button
                (click)="searchFaxInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="isActive">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCTOR.INPUT.STATUS' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let doctor">
            <span
              style="width: 61px"
              class="label label-lg label-light-{{
                getItemCssClassByStatus(doctor.is_active.toString())
              }} label-inline text-center"
            >
              {{ getItemStatusString(doctor.is_active.toString()) }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchIsActive">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCTOR.INPUT.STATUS' | translate }}</mat-label>
              <mat-select
                [(value)]="searchIsActiveSelect"
                [placeholder]="'DOCTOR.INPUT.STATUS' | translate"
                (selectionChange)="handleStatusChange()"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="true">Active</mat-option>
                <mat-option value="false">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let doctor">
            <ng-template ngxPermissionsOnly="canViewDoctor">
              <button
                matTooltip="{{ 'TABLE.VIEW' | translate }} Doctor"
                class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                (click)="viewDoctor(doctor)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/visible.svg"
                  class="svg-icon svg-icon-md svg-icon-success"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canEditDoctor">
              <button
                matTooltip="{{ 'TABLE.UPDATE' | translate }} Doctor"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="editDoctor(doctor.id)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canActivateDoctor">
              <button
                matTooltip="{{ 'TABLE.ACTIVATE_DEACTIVATE' | translate }} Doctor"
                class="btn btn-icon btn-light btn-hover-warning btn-sm m-1"
                (click)="updateSingleStatus(doctor)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/update_icon2.svg"
                  class="svg-icon svg-icon-md svg-icon-warning"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canSoftDeleteDoctor">
              <button
                matTooltip="{{ 'TABLE.DELETE' | translate }} Doctor"
                class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
                (click)="deleteDoctor(doctor)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-danger"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarColumns"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="pageSize || 25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
